export default import.meta.ROLLUP_FILE_URL_VmQ5AE85ppiZ14Nl28xtCw